import { SearchService } from '@/common/api.service'
import {
  SET_ERROR,
  POST_SEARCH,
  SEARCH_START,
  SEARCH_END,
  FETCH_DEVICES_BY_GENERIC,
  OPEN_DEVICE_SEARCH_MODAL,
  CLOSE_DEVICE_SEARCH_MODAL,
  TOGGLE_DEVICE_SEARCH_MODAL,
  SET_DEVICE_SEARCH_PARAMS,
  SET_DEVICE_SEARCH_RESULT,
  FETCH_GENERIC_CONTENT_ITEM,
  SET_GENERIC_CONTENT_ITEM,
} from '../actions.type'

export const SEARCH_RESULT_TYPE = {
  Topic: 'Topic',
  Problem: 'Problem',
  Instruction: 'Instruction',
  Device: 'Device',
}

export const state = {
  results: {},
  devices: {},
  isLoading: true,
  deviceSearchModal: {
    isOpened: false,
    genericType: '',
    genericItemId: null,
    result: [],
    genericContentItem: null,
  },
}

export const actions = {
  [POST_SEARCH](context, { query, options }) {
    context.commit(SEARCH_START)
    return SearchService.post({ query, ...options })
      .then(({ data }) => {
        context.commit(SEARCH_END, { results: data })
      })
      .catch(error => {
        throw new Error(error)
      })
  },
  [FETCH_DEVICES_BY_GENERIC](context, { query }) {
    const { genericType, genericItemId } = context.state.deviceSearchModal

    context.commit(SEARCH_START)
    return SearchService.getDevicesByGeneric({ genericItemId, genericType: genericType.toLowerCase(), query })
      .then(({ data }) => {
        context.commit(SET_DEVICE_SEARCH_RESULT, data)
      })
      .catch(error => {
        throw new Error(error)
      })
  },
  [OPEN_DEVICE_SEARCH_MODAL](context, params) {
    context.commit(SET_DEVICE_SEARCH_PARAMS, params)
    context.commit(TOGGLE_DEVICE_SEARCH_MODAL, true)
  },
  [CLOSE_DEVICE_SEARCH_MODAL](context) {
    context.commit(SET_DEVICE_SEARCH_PARAMS, {})
    context.commit(SET_DEVICE_SEARCH_RESULT, [])
    context.commit(TOGGLE_DEVICE_SEARCH_MODAL, false)
  },
  [FETCH_GENERIC_CONTENT_ITEM](context, { genericType, deviceId, cmtReferenceId }) {
    let method
    switch (genericType) {
      case SEARCH_RESULT_TYPE.Instruction:
        method = 'guides'
        break
      case SEARCH_RESULT_TYPE.Problem:
        method = 'problems'
        break
    }
    return SearchService.getGenericContentItem({ method, deviceId, cmtReferenceId })
      .then(({ data }) => {
        context.commit(SET_GENERIC_CONTENT_ITEM, data)
      })
      .catch(error => {
        throw new Error(error)
      })
  },
}

export const mutations = {
  // Global search mutations
  [SEARCH_START](state) {
    state.isLoading = true
  },
  [SEARCH_END](state, data) {
    state.results = data.results
    state.isLoading = false
  },
  [SET_ERROR](state, error) {
    state.errors = error
  },
  // Device search modal mutations
  [TOGGLE_DEVICE_SEARCH_MODAL](state, isOpened) {
    state.deviceSearchModal.isOpened = isOpened
  },
  [SET_DEVICE_SEARCH_PARAMS](state, params) {
    state.deviceSearchModal.genericType = params.genericType
    state.deviceSearchModal.genericItemId = params.genericItemId
  },
  [SET_DEVICE_SEARCH_RESULT](state, devices) {
    state.deviceSearchModal.result = devices
    state.isLoading = false
  },
  [SET_GENERIC_CONTENT_ITEM](state, item) {
    state.deviceSearchModal.genericContentItem = item
  },
}

const getters = {
  results(state) {
    return state.results
  },
  isLoading(state) {
    return state.isLoading
  },
  searchResultType() {
    return SEARCH_RESULT_TYPE
  },
  deviceSearchModal() {
    return state.deviceSearchModal
  },
}

function filterCombinedTopicDevices(list) {
  let slavesToShow = {}
  return list.filter(item => {
    const device = item.device
    if (!device) return

    if (item.hasGenericInstruction || item.hasProblem) {
      if (!device.masterId && device.slaves && device.slaves[0]) {
        slavesToShow[device.slaves[0]] = true
        return false
      } else if (slavesToShow[device.id]) {
        return true
      } else if (!device.masterId) {
        return true
      }
    } else {
      if (slavesToShow[device.id]) {
        slavesToShow[device.id] = false
        return true
      }
    }
  })
}

function convertToGenericData(item) {
  if (item.instructionInfo) {
    const topicId = item.instructionInfo.chapterId || null
    const guideId = item.instructionInfo.instuctionCmtReferenceId || null

    return {
      name: item.device.name,
      device: item.device,
      genericContentReference: {
        genericItemId: guideId,
        genericType: SEARCH_RESULT_TYPE.Instruction,
      },
    }
  } else if (item.problemInfo) {
    const topicId = item.problemInfo.chapterId || null
    const problemId = item.problemInfo.problemCmtReference || null

    return {
      name: item.device.name,
      device: item.device,
      genericContentReference: {
        genericItemId: problemId,
        genericType: SEARCH_RESULT_TYPE.Problem,
      },
    }
  }
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
}
